import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { ToastService } from './toast-service';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ListViewExpandableService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService, private toastCtrl: ToastService) { }

  getId = (): string => 'expandable';

  getTitle = (): string => 'Expandable';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'expandable/0', 'title': 'List With Avatar', 'theme': 'layout1' },
      { 'url': 'expandable/1', 'title': 'Full With Card', 'theme': 'layout2' },
      { 'url': 'expandable/2', 'title': 'Full With Image', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): Array<any> => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'List With Avatar',
      'items': [
        {
          'id': 1,
          'title': 'Sofia Madsen',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/24.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 2,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/23.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 3,
          'title': 'Carolyn Guerrero',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/17.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 4,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/18.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 5,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/19.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 6,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/20.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        },
        {
          'id': 7,
          'title': 'Benton Willis',
          'description': 'jhunt@mider.com',
          'image': 'assets/imgs/avatar/21.jpg',
          'icon': 'chevron-down',
          'items': [
            {
              'id': 1,
              'title': 'Main Street 32, NYC',
              'icon': 'location'
            },
            {
              'id': 2,
              'title': '+ 1 233 9843 2354',
              'icon': 'call'
            }
          ]
        }
      ]
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Full With Card',
      'items': [
        {
          'id': 1,
          'title': 'Nike Lebron XVII',
          'backgroundImage': 'assets/imgs/background/10.jpg',
          'button': 'BUY',
          'price': '$123.89',
          'items': [
            {
              'id': 1,
              'icon': 'scan',
              'title': 'PROMO CODE',
              'iconArrow': 'arrow-forward-circle',
            },
            {
              'id': 2,
              'icon': 'cash',
              'title': 'PAY WITH PAYPAL',
              'iconArrow': 'arrow-forward-circle',
            },
            {
              'id': 3,
              'icon': 'gift',
              'title': 'GIF CARD',
              'iconArrow': 'arrow-forward-circle',
            }

          ]
        },
        {
          'id': 2,
          'title': 'Nike Blazer Mid 77',
          'backgroundImage': 'assets/imgs/background/11.jpg',
          'button': 'BUY',
          'price': '$103.89',
          'items': [
            {
              'id': 1,
              'icon': 'scan',
              'title': 'PROMO CODE',
              'iconArrow': 'arrow-forward-circle',
            },
            {
              'id': 2,
              'icon': 'cash',
              'title': 'PAY WITH PAYPAL',
              'iconArrow': 'arrow-forward-circle',
            },
            {
              'id': 3,
              'icon': 'gift',
              'title': 'GIF CARD',
              'iconArrow': 'arrow-forward-circle',
            }

          ]
        },
        {
          'id': 3,
          'title': 'Supreme x Timberland',
          'backgroundImage': 'assets/imgs/background/14.jpg',
          'button': 'BUY',
          'price': '$423.89',
          'items': [
            {
              'id': 1,
              'icon': 'scan',
              'title': 'PROMO CODE',
              'iconArrow': 'arrow-forward-circle',
            },
            {
              'id': 2,
              'icon': 'cash',
              'title': 'PAY WITH PAYPAL',
              'iconArrow': 'arrow-forward-circle',
            },
            {
              'id': 3,
              'icon': 'gift',
              'title': 'GIF CARD',
              'iconArrow': 'arrow-forward-circle',
            }

          ]
        },
        {
          'id': 4,
          'title': 'All Star 70 x OFF-WHITE The Ten',
          'backgroundImage': 'assets/imgs/background/12.jpg',
          'button': 'BUY',
          'price': '$593.89',
          'items': [
            {
              'id': 1,
              'icon': 'scan',
              'title': 'PROMO CODE',
              'iconArrow': 'arrow-forward-circle',
            },
            {
              'id': 2,
              'icon': 'cash',
              'title': 'PAY WITH PAYPAL',
              'iconArrow': 'arrow-forward-circle',
            },
            {
              'id': 3,
              'icon': 'gift',
              'title': 'GIF CARD',
              'iconArrow': 'arrow-forward-circle',
            }

          ]
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Full With Image',
      'items': [
        {
          'title': 'Hotels in New York',
          'backgroundImage': 'assets/imgs/background/1.jpg',
          "icon": "chevron-down",
          "items": [
            {
              "id": 1,
              "title": "New York Hilton Midtown",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/1.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 2,
              "title": "New York Marriott Marquis",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/2.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 3,
              "title": "Grand Hyatt New York",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/3.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 4,
              "title": "The Roosevelt Hotel",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/4.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            }
          ]
        },
        {
          'title': 'Restaurants in New York City',
          'backgroundImage': 'assets/imgs/background/2.jpg',
          "icon": "chevron-down",
          "items": [
            {
              "id": 1,
              "title": "Kennedy Fried Chicken",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/9.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 2,
              "title": "PKorilla BBQ",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/10.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 3,
              "title": "BurritoVille",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/11.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 4,
              "title": "Mo Gridder's",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/12.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            }
          ]
        },
        {
          'title': 'The Best Pubs in New York',
          'backgroundImage': 'assets/imgs/background/3.jpg',
          "icon": "chevron-down",
          "items": [
            {
              "id": 1,
              "title": "John Sullivan’s",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/5.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 2,
              "title": "Perdition",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/6.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 3,
              "title": "4th Avenue Pub",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/7.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 4,
              "title": "O’Donnell’s Pub",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/8.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            }
          ]
        },
        {
          'title': 'Museums in New York City‎',
          'backgroundImage': 'assets/imgs/background/4.jpg',
          "icon": "chevron-down",
          "items": [
            {
              "id": 1,
              "title": "The Metropolitan Museum of Art",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/13.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 2,
              "title": "New York Public Library",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/14.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 3,
              "title": "KGB Espionage Museum",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/15.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            },
            {
              "id": 4,
              "title": "Frick Collection",
              "description": "Amazing New Place",
              "image": "assets/imgs/avatar/16.jpg",
              "details": "Main Street 32, NYC",
              "icon": "location"
            }
          ]
        }
      ]
    };
  }

  load(item: any): Observable<any> {
    this.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('listView/expandable/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            this.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            this.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        this.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
